import TeamMembersContainer from './TeamMembersContainer';

export default TeamMembersContainer;
